import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'formik';
import { compose } from 'redux';
import injectSheet from 'react-jss';
import theme from '../../../../styles/theme';

function buildField(label, value, push) {
  return (
    <span>
      <Field type="checkbox" name="interests" id={value} value={value} onChange={e => push(e.target.value)} />
      <label htmlFor={value}>
        {label}
      </label>
    </span>
  );
}

const InterestsCheckbox = ({ classes }) => (
  <FieldArray
    name="interests"
    render={({ push }) => (
      <fieldset className={classes.interests}>
        <div>
          {buildField('Curvy, Big/Tall', 'curvy-big-tall', push)}
          {buildField('Sport', 'sport', push)}
          {buildField('Designer', 'designer', push)}
          {buildField('Kids', 'kids', push)}
        </div>
      </fieldset>
    )}
  />
);

InterestsCheckbox.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default compose(
  injectSheet({
    interests: {
      border: 'none',
      padding: 0,
      margin: 0,
      '& label': {
        color: 'inherit',
      },
      '& > div': {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        width: '100%',
      },
      '& span': {
        display: 'flex',
        marginRight: '7px',
        minWidth: '100%',
        [theme.breakpoints.up('md')]: {
          minWidth: 0,
        },
      },
    },
  }),
)(InterestsCheckbox);
